import * as React from 'react';

function SvgDownload(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 22" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M18 7.33h-3.6V0H9.6v7.33H6l6 6.12zm5.21 8c-.26-.27-1.94-2.11-2.42-2.59a1.81 1.81 0 00-1.25-.51h-2.11l3.68 3.66h-4.25a.32.32 0 00-.29.17l-1 2.29H8.41l-1-2.29a.33.33 0 00-.29-.17H2.89l3.68-3.66H4.46a1.81 1.81 0 00-1.25.51c-.48.48-2.16 2.32-2.42 2.59-.58.67-.9 1.13-.79 1.76l.67 3.76A1.62 1.62 0 002.21 22h19.58a1.61 1.61 0 001.5-1.15l.71-3.76c.11-.63-.21-1.09-.79-1.77z" />
    </svg>
  );
}

const MemoSvgDownload = React.memo(SvgDownload);
export default MemoSvgDownload;
